import { render, staticRenderFns } from "./Accidentreport.vue?vue&type=template&id=6f67413e&"
import script from "./Accidentreport.vue?vue&type=script&lang=js&"
export * from "./Accidentreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports